import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, invoiceHistoryActions } from "./invoice-history-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { InvoiceLineService, InvoiceService } from "src/backend/openapi/v1";

export function* getInvoices(action: ReturnType<typeof invoiceHistoryActions.getInvoicesRequest>) {
  try {
    const result = yield* call(InvoiceService.postApiV1Invoice, action.payload.customerId, action.payload.isCreditNote, action.payload.data);
    yield put(invoiceHistoryActions.getInvoicesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(invoiceHistoryActions.getInvoicesFail());
  }
}

export function* getInvoicesWatch() {
  yield takeLeading(Action.GetInvoicesRequest, getInvoices);
}

export function* getInvoiceLines(action: ReturnType<typeof invoiceHistoryActions.getInvoiceLinesRequest>) {
  try {
    const result = yield* call(InvoiceLineService.postApiV1InvoiceLine, action.payload.invoiceId, action.payload.data);
    yield put(invoiceHistoryActions.getInvoiceLinesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(invoiceHistoryActions.getInvoiceLinesFail());
  }
}

export function* watchGetInvoiceLines() {
  yield takeLeading(Action.GetInvoiceLinesRequest, getInvoiceLines);
}

export function* invoiceHistorySaga() {
  yield all([fork(getInvoicesWatch), fork(watchGetInvoiceLines)]);
}
